import { render, staticRenderFns } from "./ServiceProviderSalesPerformance.vue?vue&type=template&id=1c50af2e"
import script from "./ServiceProviderSalesPerformance.vue?vue&type=script&lang=js"
export * from "./ServiceProviderSalesPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports